import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WrappingSerializer3cq24ex5vrdbg as WrappingSerializer } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Companion_instancegwok6qx7et5m as Companion_instance,
  get_kind27kjvyfnc9an8 as get_kind,
  get_type3f1sl153qhh1c as get_type,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  size1hf9cj08wgoyn as size,
  get_basePriority3aha966bwjyn2 as get_basePriority,
  priority7vn90mx06311 as priority,
  Generator2kgtccb0jt0mi as Generator,
} from './FormRenderer.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function WrappingSerializer$inner$ref(p0) {
  var l = (_this__u8e3s4) => p0.f3u(_this__u8e3s4);
  l.callableName = 'inner';
  return l;
}
function WrappingSerializer$outer$ref(p0) {
  var l = (_this__u8e3s4) => p0.h3u(_this__u8e3s4);
  l.callableName = 'outer';
  return l;
}
var WrapperFormRendererClass;
function WrapperFormRenderer() {
  if (WrapperFormRendererClass === VOID) {
    class $ {
      constructor() {
        this.qe1_1 = 'Wrapper';
      }
      k20() {
        return this.qe1_1;
      }
      ddu(module_0, selector) {
        var tmp = selector.edu_1;
        return tmp instanceof WrappingSerializer();
      }
      ldu(module_0, selector) {
        var tmp = selector.edu_1;
        var innerSer = tmp instanceof WrappingSerializer() ? tmp : THROW_CCE();
        var inner = module_0.ydt(selector.copyChangingType(innerSer.d3u()));
        var tmp_0 = Companion_instance;
        var tmp_1 = inner.p1();
        var tmp_2 = inner.uds();
        return tmp_0.jdx(module_0, this, selector, tmp_1, tmp_2, ($this$FormRenderer, field, mutable) => {
          var tmp = inner.tds();
          var tmp_0 = WrappingSerializer$inner$ref(innerSer);
          return tmp($this$FormRenderer, field, mutable.tak(tmp_0, WrappingSerializer$outer$ref(innerSer)));
        });
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).f94 = get_type;
    protoOf($).pdu = get_nullable;
    protoOf($).qdu = get_annotation;
    protoOf($).uds = get_handlesField;
    protoOf($).idu = size;
    protoOf($).cdu = get_basePriority;
    protoOf($).rdu = priority;
    initMetadataForObject($, 'WrapperFormRenderer', VOID, VOID, [Generator()]);
    WrapperFormRendererClass = $;
  }
  return WrapperFormRendererClass;
}
var WrapperFormRenderer_instance;
function WrapperFormRenderer_getInstance() {
  return WrapperFormRenderer_instance;
}
//region block: init
WrapperFormRenderer_instance = new (WrapperFormRenderer())();
//endregion
//region block: exports
export {
  WrapperFormRenderer_instance as WrapperFormRenderer_instance2ibtnpuvgr7bz,
};
//endregion

//# sourceMappingURL=WrapperFormRenderer.mjs.map
